import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect:"/home",
      component: (resolve) => require(['@/index.vue'], resolve),
      meta:{
        title:'派智代理人管理平台'
      },
      children:[
        {
          path: '/home',
          name: 'home',
          component: (resolve) => require(['@/components/home.vue'], resolve),
        },
        {
          path: '/myCase',
          name: 'myCase',
          component: (resolve) => require(['@/components/myCase.vue'], resolve),
        },
        {
          path: '/account',
          name: 'account',
          component: (resolve) => require(['@/components/account.vue'], resolve),
        },
        {
          path: '/allCase',
          name: 'allCase',
          component: (resolve) => require(['@/components/allCase.vue'], resolve),
        },
        {
          path: '/case_details',
          name: 'case_details',
          component: (resolve) => require(['@/components/case_details.vue'], resolve),
        },
        {
          path: '/setting',
          name: 'setting',
          component: (resolve) => require(['@/components/setting.vue'], resolve),
        },
        {
          path: '/names',
          name: 'names',
          component: (resolve) => require(['@/components/names.vue'], resolve),
        },
        {
          path: '/payList',
          name: 'payList',
          component: (resolve) => require(['@/components/payList.vue'], resolve),
        },
        {
          path: '/confirm',
          name: 'confirm',
          component: (resolve) => require(['@/components/confirm.vue'], resolve),
        },
        {
          path: '/confirm_write',
          name: 'confirm_write',
          component: (resolve) => require(['@/components/confirm_write.vue'], resolve),
        },
        {
          path: '/myMessage',
          name: 'myMessage',
          component: (resolve) => require(['@/components/myMessage.vue'], resolve),
        },
        {
          path: '/digs_list',
          name: 'digs_list',
          component: (resolve) => require(['@/components/digs/digs_list.vue'], resolve),
        },
        {
          path: '/digs_details',
          name: 'digs_details',
          component: (resolve) => require(['@/components/digs/digs_details.vue'], resolve),
        },
        {
          path: '/caseList',
          name: 'caseList',
          component: (resolve) => require(['@/components/caseList.vue'], resolve),
        },
        {
          path: '/confirm_fill',
          name: 'confirm_fill',
          component: (resolve) => require(['@/components/confirm_fill.vue'], resolve),
        },
        {
          path: '/confirm_reply',
          name: 'confirm_reply',
          component: (resolve) => require(['@/components/confirm_reply.vue'], resolve),
        },
        
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: (resolve) => require(['@/login.vue'], resolve),
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: (resolve) => require(['@/components/agreement.vue'], resolve),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js